/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Страница не найдена",
  "ComingSoon": "Скоро будет",
  "YesanPersonalFinance": "Yesan, Личные финансы",
  "Yesan": "Yesan",
  "PersonalFinance": "Личные финансы",
  "YesanDownload": "Скачать Yesan",
  "ThisWebsiteUsesCookies": "Мы используем файлы cookie для сбора и анализа информации о производительности и использовании нашего сайта, а также для предоставления функций социальных сетей. Продолжая, вы соглашаетесь с нашим",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Станьте финансово свободным",
  "inStepsAndActions": "за 8 шагов и 3 действия.",
  "TrackPlanAnalyze": "Отслеживать. Планируйте. Анализировать.",
  "FTrack": "1. Отслеживать .",
  "FPlan": "2. Планировать",
  "FAnalyze": "3. Анализировать",
  "Features": "Особенности",
  "FeaturesSubHeading": "Если вы только начинающий, но уже финансово грамотный человек, это приложение вам пригодится, чтобы стать финансово свободным.",
  "ManageAccounts": "Управление счетами",
  "CashLiquidFixedAssetsLiabilities": "Денежные средства, ликвидные средства, основные средства и обязательства.",
  "TrackTransactions": "Отслеживайте транзакции",
  "IncomesExpensesTransferInvestments": "Доходы, расходы, переводы, инвестиции.",
  "ImportExport": "Импорт / экспорт",
  "YourDataAlwaysAccessible": "Ваши данные всегда под рукой.",
  "PlanYourFreedom": "Планируйте свою свободу",
  "StepsAwayFromFI": "В 8 шагах от финансовой независимости.",
  "BudgetsAndGoals": "Бюджеты и цели",
  "CheckYourProgressAndAchieve": "Проверяйте свой прогресс и достигайте своих финансовых целей.",
  "DashboardAndAnalytics": "Приборная панель и аналитика",
  "ReviewLearnOptimizeWith": "Обзор, обучение, оптимизация с помощью графиков, аналитических данных и инструментов.",
  "Security": "Безопасность",
  "MilitaryGradeEncryption": "Шифрование военного класса, поддержка биометрии, хранение данных на ваших устройствах.",
  "OfflineMode": "Автономный режим",
  "YourDataAlwaysAccessibleAndModif": "Ваши данные всегда доступны и изменяемы.",
  "Track": "Отслеживайте",
  "Income": "Доходы",
  "Expense": "Расходы",
  "Transfer": "Передача",
  "transactionsAndManageAccounts": "транзакции и управление различными счетами:",
  "checkings": "Расчетный",
  "savings": "Сберегательные",
  "realEstate": "Недвижимость",
  "stocks": "Фондовые рынки",
  "bonds": "Облигации",
  "crypto": "Криптовалюты",
  "notes": "Банкноты, наличные Кошелек",
  "envelopes": "Конверты",
  "privateEquity": "Частный капитал",
  "metal": "Металл",
  "retirement": "Пенсионные",
  "lifeInsurance": "Страхование жизни",
  "intellectualProperty": "Интеллектуальная собственность",
  "otherLiquidAsset": "Прочие ликвидные активы",
  "otherFixedAsset": "Другие основные средства",
  "mortgage": "Ипотека",
  "loan": "Потребительский кредит",
  "creditCard": "Кредитная карта",
  "otherLiability": "Прочие пассивы",
  "AccountsManagement": "Управление счетами",
  "MultipleAccountsTypesAndGrouping": "Несколько типов счетов и их группировка",
  "LinkAccounts": "Связывание счетов с вашими учреждениями (доступно только в некоторых странах)",
  "SmartAccounts": "Интеллектуальные счета",
  "AddEditDeleteTransactions": "Добавление / редактирование / удаление транзакций",
  "TickVerifiedTransactions": "Отметить проверенные транзакции",
  "CategorizeTransactions": "Категоризация транзакций",
  "TagTransactions": "Отмечать транзакции",
  "TrackKakeiboType": "Отслеживать тип Kakeibo",
  "TrackInvestments": "Отслеживать инвестиции (доступно только в некоторых странах)",
  "ImportFromCSVFile": "Импортируйте транзакции полностью или по частям из CSV-файла",
  "ExportToCSVFile": "Экспорт транзакций в CSV-файл",
  "stepsTowardsFIPlanBudgetingReachGoals": "План \"8 шагов к финансовой независимости\", подробное составление бюджета, достижение финансовых целей быстрее.",
  "levelsTowardsFI": "8 уровней на пути к финансовой независимости",
  "EstablishBudgetsPer": "Составление бюджетов для каждого",
  "account": "счет",
  "accountType": "тип счёта",
  "KakeiboType": "тип Kakeibo",
  "category": "категория",
  "tag": "тег",
  "label": "метка",
  "TrackBudgetsPerFrequency": "Отслеживайте бюджеты по частоте",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Создавайте цели по расходам, балансу, денежным потокам, действиям",
  "TrackGoalsProgress": "Отслеживайте выполнение целей",
  "ReviewLearnOptimizeWithReportsCharts": "Обзор, обучение, оптимизация с помощью отчетов, диаграмм, трендов, инсайтов, инструментов.",
  "Dashboard": "Приборная панель",
  "FSNetWorth": "Финансовые отчеты: Чистое состояние",
  "FSPnL": "Финансовая отчетность: Отчет о прибылях и убытках / Прибыль и убытки",
  "FSBalanceSheetAssetsLiabilities": "Финансовые отчеты: Баланс, активы, пассивы",
  "FSCashFlow": "Финансовая отчетность: Отчет о движении денежных средств, дебет-кредит, потоки",
  "FSFlows": "Финансовая отчетность: Потоки",
  "FSRatios": "Финансовая отчетность: Коэффициенты",
  "TrendsMonthEnd": "Тенденции на конец месяца: Доходы и расходы, Денежный поток",
  "TrendsPerformance": "Тенденции производительности: г/г, м/м, в/в",
  "IncomeTrendsPer": "Динамика доходов на",
  "SpendingTrendsPer": "Тенденции расходов на",
  "RecurringItemsIE": "Повторяющиеся статьи: Доходы и расходы",
  "DebtProgressTrends": "Тенденции развития долга",
  "KakeiboMTDReviewTrends": "Kakeibo: Обзор MTD, последний месяц, тенденции",
  "FIWCLE": "Финансовая независимость: Настенная диаграмма, расходы по жизненной энергии",
  "DebtPaydownSnowballAvalanche": "Выплата долгов: Снежный ком, Лавина",
  "FullyCustomizableAnalyticsRange": "Полностью настраиваемый временной диапазон аналитики",
  "ContactUs": "Свяжитесь с нами",
  "Privacy": "Конфиденциальность",
  "Terms": "Условия",
  "About": "О сайте",
  "IAgreeToThe": "Я согласен с",
  "AndThe": "и",
  "PrivacyPolicy": "Политикой конфиденциальности",
  "TermsOfUse": "Условия использования",

  "DigitalSoftwareExperienceTagline": "Цифровой опыт программного обеспечения для современного мира",
  "DigitalExperience": "Цифровой опыт",
  "SoftwareForTheModernWorld": "Программное обеспечение для современного мира",
  "MobileApplications": "Мобильные приложения",
  "forConnectedAndOfflineHumans": "для подключенных и автономных людей",
  "CloudSaaS": "Облачный SaaS",
  "ResponsiveAndWebServices": "Отзывчивые и веб-сервисы",
  "PersonalFinanceServices": "Услуги в области личных финансов",
  "YS_p1": "Yesan - динамично развивающаяся компания, специализирующаяся на разработке передовых мобильных приложений, предназначенных для потребителей. Хорошо понимая меняющиеся потребности и предпочтения современных пользователей, Yesan стремится создавать интуитивно понятные, увлекательные и многофункциональные мобильные приложения, которые обогащают жизнь пользователей.",
  "YS_p2": "В основе миссии Yesan лежит неустанное стремление к инновациям и творчеству. Каждый продукт тщательно разрабатывается, чтобы обеспечить бесперебойную функциональность и исключительный пользовательский опыт.",
  "PersonalFinanceApplication": "Приложение для личных финансов",
  "YPF_p1": "Yesan, Personal Finance - это передовое мобильное приложение для управления личными финансами, разработанное для того, чтобы предоставить пользователям всесторонние инструменты управления финансами, удобно расположенные на кончиках их пальцев. Благодаря гладкому и интуитивно понятному интерфейсу Yesan, Personal Finance предлагает целостный подход к управлению финансами, ориентированный на пользователей с любым уровнем финансовой грамотности.",
  "YPF_p2": "Ключевые функции включают в себя отслеживание бюджета, категоризацию расходов и мониторинг транзакций в режиме реального времени, что позволяет пользователям без труда получить представление о своих привычках расходования средств. Приложение также предлагает настраиваемые параметры бюджетирования, позволяя пользователям ставить финансовые цели и отслеживать их достижение с течением времени.",
  "YPF_p3": "Кроме того, \"Есан, личные финансы\" уделяет большое внимание безопасности, используя самые современные протоколы шифрования для защиты конфиденциальной финансовой информации пользователей. Благодаря мерам безопасности банковского уровня пользователи могут уверенно связывать свои счета и синхронизировать транзакции без ущерба для конфиденциальности.",
  "YPF_p4": "Yesan, Personal Finance выходит за рамки базового бюджетирования, предлагая глубокую аналитику и персонализированные рекомендации для оптимизации финансовых решений. Будь то выявление потенциальных возможностей для экономии, мониторинг инвестиционных портфелей или управление стратегиями погашения долгов, приложение предоставляет индивидуальные рекомендации, чтобы помочь пользователям достичь своих финансовых целей.",
  "Discover": "Откройте для себя",
  "Firstname": "Имя и фамилия",
  "Lastname": "Фамилия",
  "Company":"Компания",
  "Subject": "Тема",
  "Email": "Электронная почта",
  "Message": "Сообщение",
  "ThankYouForContactingUs": "Спасибо, что связались с нами",
  "ValidFirstnameRequired": "Необходимо ввести правильное имя и фамилию.",
  "ValidLastnameRequired": "Необходимо ввести действительное имя и фамилию.",
  "ValidEmailAddressRequired": "Пожалуйста, введите действительный адрес электронной почты.",
  "ValidSubjectRequired": "Пожалуйста, выберите правильную тему.",
  "ValidMessageRequired": "Пожалуйста, введите правильное сообщение.",
  "UnableToSendTheFormPleaseRetryLater": "Невозможно отправить форму, пожалуйста, повторите попытку позже.",
  "Information": "Информация",
  "Sales":"Продажи",
  "Support": "Поддержка",
  "Press": "Пресса",
  "Partnership": "Партнерство",
  "Other": "Другое",
  "Blog":"Блог",

  "Accept":"Принять",
  "Decline":"Отклонить",

  "WorklogCalendar":"Календарь Worklog для Jira",

  "DirectlyAccessibleInProjectApps":"Прямой доступ в приложениях проекта",
  "VisualizeWhereYouSpentYourTime":"Визуализация того, на что вы потратили время",
  "AllYourWorklogsInACalendar":"Все ваши рабочие журналы в календаре",
  "MonthSummary":"Сводка за месяц",
  "CheckIfYouForgotToLogTime":"Проверьте, не забыли ли вы занести время в журнал.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Прямой доступ к вопросам и обновление времени",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Нажмите на элемент рабочего журнала, чтобы получить прямой доступ к вопросам и отредактировать отслеженное время.",
  "AlsoAvailableInDarkMode":"Также доступно в темном режиме",
  "DirectlyLogWorkOnTheCalendarVisually":"Непосредственно визуально регистрируйте работу в календаре",
  "ClickOnTheCalendarToCreateNewWorklog":"Нажмите на календарь, чтобы создать новый рабочий журнал",

  "AppsForAtlassian":"Приложения для Atlassian",
  "YCL_p1":"Визуализируйте все свои рабочие журналы в календаре с отображением месяца, недели, рабочей недели, дня.",
  "YCL_p2":"Записывайте работу прямо из календаря, визуально выбирая временной интервал.",
  "YCL_p3":"Определите, не забыли ли вы отследить время в табеле учета рабочего времени.",
  "YCL_p4":"Доступно на вашем языке: Английский (Великобритания), Английский (США), Китайский (упрощенный), Китайский (традиционный), Чешский, Датский, Голландский, Эстонский, Финский, Французский, Немецкий, Венгерский, Исландский, Итальянский, Японский, Корейский, Норвежский, Польский, Португальский (Бразилия), Португальский (Португалия), Русский, Испанский, Шведский, Турецкий.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Финансовый портфель для Jira",
  "BringRealFinancialPortfolio":"Внедрите в Jira управление реальным финансовым портфелем. Отслеживайте бюджеты, капитальные и операционные расходы, а также затраты на проекты в одном месте.",
  "YFPAboutQ":"Сколько на самом деле стоят нам наши проекты в Jira?",
  "YFPAbout":"Финансовый портфель для Jira\nРуководители финансовых отделов и PMO с трудом отвечают на простой вопрос:\nСколько на самом деле стоят нам наши проекты в Jira?\nJira отслеживает работу.\nФинансовый отдел отслеживает бюджеты.\nЭто приложение наконец-то связывает эти два компонента.\n\nФинансовый портфель превращает Jira в легкую платформу PPM + финансового планирования — без необходимости использования дорогостоящих корпоративных инструментов.",
  "YFPPorfolioQ":"Бюджеты и отслеживание портфелей",
  "YFPPorfolioP":"Создавайте портфели, объединяющие несколько проектов Jira, и определяйте: сумму бюджета, валюту, диапазон дат, включенные проекты и команды. Автоматически отслеживайте фактические затраты по мере выполнения работы в Jira.",
  "YFPPorfolioListQ":"Портфели",
  "YFPPorfolioListP":"Создавайте финансовые портфели, объединяющие несколько проектов Jira, и мгновенно просматривайте: соотношение бюджета и фактических затрат, скорость расходования средств проекта в реальном времени, разбивку по капитальным и операционным затратам, затраты на задачу и проект, а также финансовые отчеты, доступные для экспорта. Все это работает напрямую на основе рабочих журналов Jira.",
  "CostQ":"Автоматический расчет затрат",
  "CostP":"Превратите учет рабочего времени в реальные финансовые данные. Приложение: считывает журналы работ Jira, применяет почасовые ставки, ежедневно рассчитывает реальные затраты по проекту. Без таблиц. Без ручной работы.",
  "RatesQ":"Ставки",
  "RatesP":"Устанавливайте почасовую ставку для проекта, команды или глобально",
  "ReportQ":"Финансовая отчетность в формате CSV",
  "ReportP":"Экспортируйте финансовые данные портфеля за секунды. Идеально подходит для: финансовых команд, отчетности финансового директора, планирования бюджета, поддержки аудита",
  "SettingsQ":"Классификация CapEx и OpEx",
  "SettingsP":"Поддержка требований бухгалтерского учета и аудита. Классификация работы на: капитализируемые разработки (CapEx) и операционную работу (OpEx). Создание готовых к экспорту отчетов для финансовых команд."
};

export const documents = {
};
